/**
 * Hue rotation applied to sprites tinted by the player's sword, indexed by
 * sword level.
 */
export const SWORD_HUES: readonly number[] = [0, -32, -112, -180];

/** Glow colour of the blade itself, indexed by sword level. */
export const SWORD_COLOURS: readonly number[] = [
  64767, 65376, 16776192, 16714752,
];

/** Glow colour of a score popup earned with a multiplier, by sword level. */
export const SCORE_POP_GLOW: readonly number[] = [
  1073912, 53800, 15121664, 14680064,
];

/** Glow colour of a score popup earned without a multiplier. */
export const SCORE_POP_GLOW_PLAIN = 13500630;
